import Vue from 'vue'

const defaultState = () => ({
    'start_at': null,
    'end_at': null,
    'client_id': null,
    'our_company_id': null,
    'responsible_salesman_id': null,
    'transportation_type_id': null,
    'type': null
})

const COMPANY_FILTER = {
    namespaced: true,
    state: defaultState(),
    getters: {
        getBookingFilter: state => state,
        getBookingFilterPayload: (state, getters) => {
            return {
                'search[start_at]': state.ourCompany || null,
                'search[end_at]': state.phone || null,
                'search[client_id]': state.email || null,
                'search[our_company_id]': state.link || null,
                'search[responsible_salesman_id][full_name]': state.contactFio || null,
                'search[transportation_type_id][emails][email]': state.contactEmail || null,
            }
        }
    },
    mutations: {
        UPDATE_BOOKING_FILTER (state, payload) {
            Vue.set(state, payload.field, payload.value)
        },
        BOOKING_CLEAR_FILTER (state) {
            Object.assign(state, defaultState())
        }
    },
}

export default COMPANY_FILTER
